export var SparkEngineStatus;
(function (SparkEngineStatus) {
    SparkEngineStatus["SPARK_ENGINE_STATUS_CREATING"] = "CREATING";
    SparkEngineStatus["SPARK_ENGINE_STATUS_CREATE_FAILED"] = "CREATE_FAILED";
    SparkEngineStatus["SPARK_ENGINE_STATUS_STOPPED"] = "STOPPED";
    SparkEngineStatus["SPARK_ENGINE_STATUS_STARTING"] = "STARTING";
    SparkEngineStatus["SPARK_ENGINE_STATUS_STARTED"] = "STARTED";
    SparkEngineStatus["SPARK_ENGINE_STATUS_STOPPING"] = "STOPPING";
    SparkEngineStatus["SPARK_ENGINE_STATUS_DELETING"] = "DELETING";
    SparkEngineStatus["SPARK_ENGINE_STATUS_FORCE_DELETING"] = "FORCE_DELETING";
})(SparkEngineStatus || (SparkEngineStatus = {}));
